import styled from '@emotion/styled';
import { Card } from '@material-ui/core';

export const CardWithHover = styled(Card)<{
  highlighted?: boolean;
  noPointer?: boolean;
}>`
  cursor: ${(p) => (p.noPointer ? 'default' : 'pointer')};
  background: ${(p) => p.theme.custom.colors.background.light};
  &:hover {
    box-shadow: 0 0 0 4px rgba(119, 128, 136, 0.1);
  }
  &:active {
    background-color: ${(p) => p.theme.custom.colors.gray.w100};
    box-shadow: 0 0 0 4px rgba(119, 128, 136, 0.1);
  }
`;
